<style lang="scss">
.AuthorizerLogin {
  &__lost {
    margin: .25em .25em 0 0;
    font-size: 1rem;
    text-align: right;
    a {
      color: black;
      text-decoration: underline;
    }
  }

  .spinner {
    width: 2.5rem;
    height: 2.5rem;
    margin: .25rem 0 0;
    color: inherit;
  }

  .OauthButtons {
    flex: 1 1 auto;
    margin-right: 2rem;
  }

}
</style>

<template>
<form
  class="AuthorizerForm AuthorizerLogin"
  name="authorizer-login"
  @submit.prevent="submit">

  <div class="AuthorizerForm__fieldset">

    <InputText class="input-text"
      :error="loginError"
      name="auth-login"
      autocomplete="off"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="Email"
      @blur="atLoginBlur"
      @input="atLoginInput"
      v-model="modelValue"/>

    <InputText class="input-text" type="password"
      name="auth-password"
      autocomplete="off"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="Password"
      v-model="passwordValue"/>

    <div class="AuthorizerLogin__lost" v-if="!signup">
      <a @click="$emit('clickForgotten')">Password forgotten?</a>
    </div>
  </div>

  <div class="AuthorizerForm__submit">
    <OauthButtons/>
    <button class="button" @click.prevent="submit" :disabled="pending || disabled">
      <spinner class="spinner" v-if="pending"/>
      <span v-else>{{signup ? "Sign up" : "Login"}}</span>
    </button>
  </div>

  <div class="AuthorizerForm__bottom">
    <template v-if="signup">
      <p>Already have an account?</p>
      <a @click="switchAction()">Log in</a>
    </template>
    <p v-else>
      No account?
      <a @click="switchAction()">Sign up</a>
    </p>
  </div>

</form>
</template>

<script>
import InputText from '@/components/input-text/InputText.vue';
import { AuthAction } from './Authorizer.vue';
import OauthButtons from './OauthButtons.vue';
export default {
  name: 'AuthorizerFormLogin',
  components: { InputText, OauthButtons },
  emits: ['update:modelValue', 'clickForgotten'],
  inject: {
    $client: {
      from: 'client',
    }
  },
  props: {
    signup: {type: Boolean, default: false},
    modelValue: {type: String, default: ''},
  },
  data() {
    return {
      loginError: '',
      passwordValue: '',
      pending: false,
    };
  },
  mounted() {
    this.checkEmail();
  },
  methods: {

    /** switch \<Authorizer\> action */
    switchAction() {
      const authAction = this.signup ? AuthAction.login : AuthAction.signup;
      this.$parent.authAction = authAction;
    },

    async submit() {
      this.pending = true;

      const action = `user/${this.signup ? 'signup' : 'login'}`;
      const {modelValue: login, passwordValue: password} = this;
      const {data, error} = await this.$store.dispatch(action, {login, password});
      console.log(this.signup ? 'signup' : 'login', error, data);

      this.pending = false;

      if (error || data) this.loginError = error || 'Unexpected error';
      else this.$emit('success');
    },

    atLoginInput(inputValue = '') {
      this.loginError = '';
      const {modelValue: login} = this;
      this.$emit('update:modelValue', login);
    },

    atLoginBlur() {
      this.loginError = '';
      const {modelValue: login} = this;

      this.checkEmail();
    },

    async checkEmail() {
      const email = this.modelValue.trim();
      if (!this.signup || !email) return false;

      let error = '';
      const result = await this.$client.post('/isemailexist/', {email})
        .then(res => res.status !== 200 ? (error = `Error (${res.status})`, null) : res.data)
        .catch(err => (error = err.response?.data?.detail || err.toString(), null));

      if (result?.exist === true) this.loginError = 'That email is already registered';
      else if (error) this.loginError = error;

      return result?.exist === true;
    },
  },
  computed: {
    disabled() {
      const {passwordValue: password, loginError} = this;
      const login = this.modelValue.trim();
      // return !!loginError || !login || !password;
      return !login || !password;
    }
  },
}
</script>
